export default {
    processSubjects: [],
    processEntries: [],
    processEntryAttachments: [],
    processSubjectLoading: false,
    processEntryLoading: false,
    filters: setInitialWikiFilters(),
    setInitialWikiFilters: setInitialWikiFilters,
}

function setInitialWikiFilters() {
    return {
        primarySubjects: true,
        text: ''
    }
}